import {ReactNode, useMemo, useState} from "react";
import {TreeBenhAnNode} from "../../../models/BenhAnModel";
import {BenhAnContext, initialBenhAnContextValue} from "../../../contexts/BenhAnContext";
import {localStorageItem} from "../../../../utils/LocalStorage";
import {KEY_LOCALSTORAGE} from "../../../../auth/core/_consts";

type ContextProviderProps = {
  children: ReactNode;
};

export const BenhAnContextProvider = ({ children }: ContextProviderProps) => {
  const [phieuBenhAn, setPhieuBenhAn] = useState<TreeBenhAnNode>(initialBenhAnContextValue);
  const accessToken = localStorageItem.get(KEY_LOCALSTORAGE.ACCESS_TOKEN_DECODE) || {};
  const userMetaData = localStorageItem.get(KEY_LOCALSTORAGE.USER_METADATA) || {};
  const currentUser = {
    name: accessToken.pdn,
    fullName: accessToken.pdn,
    personId: accessToken.pid,
    ...userMetaData,
  };

  const contextValue = useMemo(() => ({
    currentUser,
    phieuBenhAn,
    setPhieuBenhAn,
  }), [phieuBenhAn, currentUser]);

  return (
    <BenhAnContext.Provider value={contextValue}>
      {children}
    </BenhAnContext.Provider>
  );
};